'use strict';

angular.module('theme').service('LogService', function ($http) {
	this.log = function (customerId, type, msg) {
		return $http({
			url: '/backapi/logEvent',
			method: 'POST',
			data: {
				customerID: customerId,
				logType: type,
				logMessage: msg,
				warnSupport: false,
			},
		});
	};
});
